module.exports = __webpack_public_path__ + "images/EVENT-BACKGROUND.6f1cea70.jpeg";